import React from "react";

function SectionHeading({ heading }) {
  return <h2 className="font-extrabold text-black">{heading}</h2>;
}

export default SectionHeading;
